import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  actions?: ReactNode;
  padded?: boolean;
}

export function Card({ title, actions, padded = true, className, children, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'bg-white dark:bg-[#1A1A2E] border border-[#E3E3F1] dark:border-[#2A2A4A] rounded-lg shadow-[0_1px_2px_rgba(15,23,42,0.06)]',
        className,
      )}
      {...rest}
    >
      {(title || actions) && (
        <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-[#E3E3F1] dark:border-[#2A2A4A]">
          {title ? <div className="text-sm font-semibold text-[#12122C] dark:text-white">{title}</div> : <span />}
          {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </div>
      )}
      <div className={padded ? 'p-5' : ''}>{children}</div>
    </div>
  );
}
